import { Box, Fade, Typography } from '@mui/material'
import { IconServerlessFramework } from '_app/icons/IconServerlessFramework'
import { Button } from 'common/components/Button'

export const CliAuth = () => {
  return (
    <Box
      height="100%"
      width="100%"
      position="fixed"
      zIndex="999"
      top="0px"
      left="0px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      overflow="scroll"
    >
      <Fade in>
        <Box display="flex" flexDirection="column" alignItems="center" gap="20px">
          <IconServerlessFramework size={70} />
          <Typography variant="h4">CLI Successfully Logged In</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              window.location.href = '/'
            }}
            style={{
              paddingLeft: 48,
              paddingRight: 48,
            }}
          >
            Continue to Dashboard
          </Button>

          <Typography variant="textPrimary" color="text.secondary">
            (or, just close this window, and go back to your terminal)
          </Typography>
        </Box>
      </Fade>
    </Box>
  )
}
export default CliAuth
